import { Provider } from "components/crime/CrimeContext";
import { CrimeList } from "components/crime/CrimeList";
import React from "react";

export const Crimes = () => {
    return (
        <Provider>
            <CrimeList />
        </Provider>
    );
};
